// extracted by mini-css-extract-plugin
module.exports = {"footerContent":"RulesFooter_footerContent__3Gokp"};